import React from 'react'
import PropTypes from 'prop-types'

import './sliderImage.scss'


const SliderImage = ({
  src,
  mobile,
  alt,
  title,
  width,
  height,
}) => (
  <div className="slider-image">
    <picture>
      {mobile && mobile.length > 0 ? mobile.map(item => (
        <source
          srcSet={item.src}
          media={item.media}
        />
      )) : null}
      <img loading="lazy" src={src} width={width} height={height} alt={alt} title={title}/>
    </picture>
  </div>
)

SliderImage.defaultProps = {
  alt: '',
  title: '',
}

SliderImage.propTypes = {
  src: PropTypes.string.isRequired,
  mobile: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
    }),
  ),
  alt: PropTypes.string,
  title: PropTypes.string,
}

SliderImage.defaultProps = {
  mobile: null,
}

export default SliderImage
